import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { hasClass } from '@opten/dom/has-class';
declare const moment;
declare const Pikaday;

@Component({ className: 'js-datepicker-field', observe: true })
export default class Datepicker implements OnInit {
    private _locales: {
        i18n?: {
            previousMonth?: string;
            nextMonth?: string;
            months?: string[];
            weekdays?: string[];
            weekdaysShort?: string[];
        };
        yearRange?: number | number[];
    };

    constructor(private element: HTMLInputElement) {}

    onInit() {
        this._locales = {
            i18n: {
                previousMonth: this.element.getAttribute('data-previous-month'),
                nextMonth: this.element.getAttribute('data-next-month'),
                months: JSON.parse(this.element.getAttribute('data-months')),
                weekdays: JSON.parse(
                    this.element.getAttribute('data-weekdays')
                ),
                weekdaysShort: JSON.parse(
                    this.element.getAttribute('data-weekdays-short')
                )
            },
            yearRange: JSON.parse(this.element.getAttribute('data-year-range'))
        };

        moment.locale(this.element.getAttribute('data-locale'));

        new Pikaday({
            field: this.element,
            yearRange: this._locales.yearRange,
            i18n: this._locales.i18n,
            format: 'DD.MM.YYYY',
            onSelect: date => {
                const inputElement = document.getElementById(
                    `${this.element.id}_hidden`
                ) as HTMLInputElement;

                inputElement.value = date
                    ? moment(date).format('YYYY-MM-DD')
                    : null;

                const event = document.createEvent('HTMLEvents');
                event.initEvent('change', false, true);
                inputElement.dispatchEvent(event);
            }
        });
    }
}

export function getDatepicker(
    input: HTMLInputElement
): HTMLInputElement | null {
    if (!input || !hasClass(input, 'js-datepicker-field-hidden')) {
        return null;
    }

    return document.querySelector<HTMLInputElement>(
        `input[name='${input.name}_datepicker'].js-datepicker-field`
    );
}
